/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@angular/router';
import * as i3 from '../../app/app.component';
import * as i4 from '../../app/services/util/loading.service';
const styles_AppComponent:any[] = ([] as any[]);
export const RenderType_AppComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_AppComponent,
    data:{}});
function View_AppComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),0,'div',[['class',
      'overlay']],(null as any),(null as any),(null as any),(null as any),(null as any)))],
      (null as any),(null as any));
}
export function View_AppComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_AppComponent_1)),i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,
      i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),
      ['\n'])),(_l()(),i0.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(212992,(null as any),0,i2.RouterOutlet,[i2.ChildrenOutletContexts,i0.ViewContainerRef,
          i0.ComponentFactoryResolver,[8,(null as any)],i0.ChangeDetectorRef],(null as any),
          (null as any)),(_l()(),i0.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i3.AppComponent = _v.component;
    const currVal_0:any = _co.showSpinner();
    _ck(_v,1,0,currVal_0);
    _ck(_v,4,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'app-my-app',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i0.ɵdid(114688,(null as any),0,i3.AppComponent,[i0.ElementRef,i4.LoadingService],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AppComponentNgFactory:i0.ComponentFactory<i3.AppComponent> = i0.ɵccf('app-my-app',
    i3.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovUHJvamVjdHMvR2l0SHViL2VkdWNhdGlvbi1lZS13ZWIvc3JjL2FwcC9hcHAuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0Q6L1Byb2plY3RzL0dpdEh1Yi9lZHVjYXRpb24tZWUtd2ViL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cyIsIm5nOi8vL0Q6L1Byb2plY3RzL0dpdEh1Yi9lZHVjYXRpb24tZWUtd2ViL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRDovUHJvamVjdHMvR2l0SHViL2VkdWNhdGlvbi1lZS13ZWIvc3JjL2FwcC9hcHAuY29tcG9uZW50LnRzLkFwcENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJvdmVybGF5XCIgKm5nSWY9XCJzaG93U3Bpbm5lcigpXCI+PC9kaXY+XHJcbjxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD5cclxuIiwiPGFwcC1teS1hcHA+PC9hcHAtbXktYXBwPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7Ozs7b0JBQUE7TUFBQSw2QkFBQTtvQkFBQSxtQ0FBaUQ7TUFBQSxTQUNqRDtNQUFBO2FBQUE7c0NBQUE7VUFBQSxlQUErQjs7SUFEVjtJQUFyQixXQUFxQixTQUFyQjtJQUNBOzs7O29CQ0RBO01BQUE7YUFBQTtVQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/$$_gendir/app/app.component.ngfactory.ts